import { createFileRoute, redirect } from '@tanstack/react-router'
import { getNavData } from '@/widgets/sidebar/navData'

// The section has no page of its own — `/warehouse` (the sidebar's «Склад»
// link) opens the first sub-page the user's roles can read.
export const Route = createFileRoute('/_protected/warehouse/')({
  beforeLoad: ({ context }) => {
    const { abilities } = context.abilityStore
    const pages =
      getNavData().find((item) => item.key === 'warehouse')?.children ?? []
    const target = pages.find(
      (page) => page.path && abilities.can('read', page.key),
    )
    throw redirect({ to: target?.path ?? '/forbidden', replace: true })
  },
})
